import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiRadio, FiUsers, FiSignal } = FiIcons;

const VideoPlayer = () => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6 }}
      className="relative"
    >
      {/* Currently Broadcasting Banner */}
      <div className="bg-gradient-to-r from-red-600 to-red-700 text-white px-4 py-3 rounded-t-xl">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-white rounded-full animate-pulse"></div>
              <span className="font-bold text-sm">LIVE NOW</span>
            </div>
            <div className="hidden sm:flex items-center space-x-4 text-sm">
              <div className="flex items-center space-x-1">
                <SafeIcon icon={FiSignal} className="text-xs" />
                <span>HD Quality</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Video Player Container */}
      <div className="relative bg-black rounded-b-xl overflow-hidden shadow-2xl">
        <div className="relative">
          {isLoading && (
            <div className="absolute inset-0 bg-black flex items-center justify-center z-10">
              <div className="text-center">
                <SafeIcon icon={FiRadio} className="text-blue-400 text-4xl mb-4 animate-pulse mx-auto" />
                <p className="text-white">Loading Live Stream...</p>
              </div>
            </div>
          )}
          <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }} className="w-full">
            <iframe
              src="https://player.viloud.tv/embed/channel/5543737368df6a5ee58e6f6346473b49?autoplay=0&volume=1&controls=1&title=1&share=1&open_playlist=0&random=0"
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              frameBorder="0"
              allow="autoplay"
              allowFullScreen
              onLoad={() => setIsLoading(false)}
              title="Ligon Road Innovations LLC Television Live Stream"
            />
          </div>
        </div>

        {/* Video Controls Overlay - Added pointer-events-none so clicks pass through to the player */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4 pointer-events-none">
          <div className="flex items-center justify-end text-white">
            <div className="flex items-center space-x-2 text-sm">
              <span className="bg-red-600 px-2 py-1 rounded text-xs font-bold">LIVE</span>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default VideoPlayer;